import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Icon from '../../components/Icon';
const Wrapper = styled.div `
  display: flex;
  padding: ${({ theme }) => theme.spacing.base}px;
  border: 2px solid
    ${({ theme, $variant }) => theme.notificationBar[$variant].badgeBackground};
  border-radius: 10px;
  background-color: ${({ theme, $variant }) => theme.notificationBar[$variant].background};
`;
const TextContent = styled.p `
  margin-left: ${({ theme }) => theme.spacing.base}px;
  font-size: ${({ theme }) => theme.fontSizes.root}px;
  line-height: ${({ theme }) => theme.lineHeights.root};
`;
const CustomIcon = styled(Icon) `
  color: ${({ theme, $variant }) => theme.notificationBar[$variant].badgeBackground};
`;
const iconMap = {
    info: 'faInfoCircle',
    error: 'faTriangleExclamation',
    success: 'faCheckCircle',
    warning: 'faExclamationCircle'
};
const Alert = ({ children, className, variant }) => {
    const iconName = iconMap[variant];
    return (_jsxs(Wrapper, Object.assign({ "$variant": variant, className: className, "data-testid": "alert-wrapper" }, { children: [_jsx(CustomIcon, { name: iconName, size: "xl", "$variant": variant }), _jsx(TextContent, { children: children })] })));
};
export default Alert;
//# sourceMappingURL=index.js.map